import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcHub = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 4.8285,
			height: 4.8285,
			transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 12.4277 10.8281)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 5.6,
			height: 5.6,
			rx: 2.8,
			transform: "matrix(1 0 0 -1 4.80078 17.5996)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.8,
			height: 4.8,
			transform: "matrix(1 0 0 -1 14.4004 17.5996)",
			fill: "white"
		})
	]
});
export default SvgIcHub;
